export function productNotAvailable(status: string): boolean {
    return status.toLowerCase().trim() === 'not available'
}
